import { useContextError } from "common-frontend-components";
import { SurveyLayoutContext } from "./surveyLayoutContext";

export const useSurveyLayout = () => useContextError(SurveyLayoutContext.name, SurveyLayoutContext);
